import type { Position } from '../../../shared/types';

const EARTH_CIRCUMFERENCE = 40075016;
const ADJUST_SCALE_TO_FIT_THE_CIRCLE = 3;

/**
 * Picks a map zoom level that fits a cluster of signatures of the given size around its center point.
 * See https://wiki.openstreetmap.org/wiki/Zoom_levels#Distance_per_pixel_math
 */
export const pickZoomLevel = (clusterSize: number, center: Position) => {
	if (clusterSize === 0) {
		return 7;
	}
	if (Math.abs(center.latitude) > 89) {
		return 4;
	}

	const scale =
		(EARTH_CIRCUMFERENCE * Math.cos((Math.PI * center.latitude) / 180)) /
		(ADJUST_SCALE_TO_FIT_THE_CIRCLE * clusterSize * 100000);
	return Math.log(scale) / Math.LN2;
};
